import { Dialog } from "@rio-cloud/rio-uikit";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { userType } from "..";
import { fetchDeletedSchedule } from "../../../api/fetchScheduling";

interface IDeleteAppointmentDialogProps {
    scheduleId?: string;
    showDialog: boolean;
    handleClose: () => void;
    userType: userType;
}

type DialogContent = "confirm" | "success";

const DeleteAppointmentDialog = (props: IDeleteAppointmentDialogProps) => {
    const navigate = useNavigate();
    const [dialogContent, setDialogContent] = useState<DialogContent>("confirm");
    const [loading, setLoading] = useState(false);

    const deleteAppointment = async () => {
        setLoading(true);
        try {
            await fetchDeletedSchedule(props.scheduleId!);
            setDialogContent("success");
        } catch (err) {
            console.error("Erro ao cancelar o agendamento:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            show={props.showDialog}
            onClose={props.handleClose}
            showCloseButton
            bsSize={Dialog.SIZE_SM}
        >
            {dialogContent === "confirm" && (
                <>
                    <Dialog.Title title={"Cancelar agendamento"} />
                    <Dialog.Body>
                        <div className="cancel-content flex flex-col">
                            <span className="text-color-darker text-size-16 text-normal">
                                Você realmente gostaria de cancelar ou reagendar?
                            </span>
                            <span className="text-color-darker text-bold text-size-18 padding-top-10">
                                Atenção!
                            </span>
                            <span
                                style={{ color: "#E36E19" }}
                                className="text-size-16 padding-top-5"
                            >
                                Após cancelar, essa ação não poderá ser desfeita.
                            </span>
                        </div>
                    </Dialog.Body>
                    <Dialog.Footer>
                        <div className="flex items-center justify-between">
                            {!loading ? <p
                                className="text-bold text-size-16 cursor-pointer text-color-primary"
                                onClick={props.handleClose}
                            >
                                Voltar
                            </p> : <p></p>}
                            <div className="flex gap-6">
                                <button
                                    type="button"
                                    className={`btn btn-default ${loading ? 'btn-loading' : ''}`}
                                    onClick={() => deleteAppointment()}
                                    disabled={loading}
                                >
                                    Cancelar agendamento
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => navigate(`/${props.userType}/appointments/appointment?scheduling-id=${props.scheduleId}`)}
                                    disabled={loading}
                                >
                                    Reagendar
                                </button>
                            </div>
                        </div>
                    </Dialog.Footer>
                </>
            )}

            {dialogContent === "success" && (
                <>
                    <Dialog.Title title={"Agendamento Cancelado"} />
                    <Dialog.Body>
                        <div className="cancel-content flex flex-col">
                            <span className="text-size-14 text-normal info-cancel">
                                Cancelamento realizado com sucesso
                            </span>
                            <span className="text-color-darker text-bold text-size-18 padding-top-10">
                                Atenção!
                            </span>
                            <span
                                style={{ color: "#B42318" }}
                                className="text-size-16 padding-top-5"
                            >
                                Essa ação não pode ser desfeita.
                            </span>
                        </div>
                    </Dialog.Body>
                    <Dialog.Footer>
                        <p
                            onClick={() => {
                                props.handleClose();
                                window.location.reload();
                            }}
                            className="text-bold text-size-16 cursor-pointer text-color-primary"
                        >
                            Fechar
                        </p>
                    </Dialog.Footer>
                </>
            )}
        </Dialog>
    );
}

export default DeleteAppointmentDialog;